import { Outlet } from "react-router-dom";

/** Admin Center pages share the shell; each page renders its own PageHead. */
export default function AdminLayout(): React.JSX.Element {
  return <Outlet />;
}
